import { generateTestId } from "@client-shared";

export const setBatchOrdersTableTestId = (identifier: string): string => generateTestId("BatchOrdersTable", identifier);

export const setBatchOrdersTableContainerTestId = (): string => setBatchOrdersTableTestId("container");
